/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_5_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconcile a real workbook in three passes`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_5_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分三轮核对实际工作簿`)
};

/**
* | output |
* | --- |
* | "Reconcile a real workbook in three passes" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_5_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_5_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_5_title(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_5_title(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_5_title as "gc.search_guides.gridcraft_excel_compatibility.sections.5.title" }